__turbopack_export_value__({
  "body-logo-18": "CreateReviewModal-module-scss-module__NFtTXa__body-logo-18",
  "body-text-12": "CreateReviewModal-module-scss-module__NFtTXa__body-text-12",
  "body-text-14": "CreateReviewModal-module-scss-module__NFtTXa__body-text-14",
  "body-text-16": "CreateReviewModal-module-scss-module__NFtTXa__body-text-16",
  "body-text-18": "CreateReviewModal-module-scss-module__NFtTXa__body-text-18",
  "body-text-20": "CreateReviewModal-module-scss-module__NFtTXa__body-text-20",
  "body-text-24": "CreateReviewModal-module-scss-module__NFtTXa__body-text-24",
  "body-text-24-2": "CreateReviewModal-module-scss-module__NFtTXa__body-text-24-2",
  "body-text-heading-2": "CreateReviewModal-module-scss-module__NFtTXa__body-text-heading-2",
  "body-text-heading-3": "CreateReviewModal-module-scss-module__NFtTXa__body-text-heading-3",
  "body-text-medium-14": "CreateReviewModal-module-scss-module__NFtTXa__body-text-medium-14",
  "body-text-medium-16": "CreateReviewModal-module-scss-module__NFtTXa__body-text-medium-16",
  "body-text-medium-18": "CreateReviewModal-module-scss-module__NFtTXa__body-text-medium-18",
  "body-text-medium2-18": "CreateReviewModal-module-scss-module__NFtTXa__body-text-medium2-18",
  "body-text2-14": "CreateReviewModal-module-scss-module__NFtTXa__body-text2-14",
  "body-text2-16": "CreateReviewModal-module-scss-module__NFtTXa__body-text2-16",
  "button-primary-text": "CreateReviewModal-module-scss-module__NFtTXa__button-primary-text",
  "button-text": "CreateReviewModal-module-scss-module__NFtTXa__button-text",
  "button2-text": "CreateReviewModal-module-scss-module__NFtTXa__button2-text",
  "card-shadow": "CreateReviewModal-module-scss-module__NFtTXa__card-shadow",
  "effect-menu": "CreateReviewModal-module-scss-module__NFtTXa__effect-menu",
  "form": "CreateReviewModal-module-scss-module__NFtTXa__form",
  "form__button": "CreateReviewModal-module-scss-module__NFtTXa__form__button",
  "form__caption": "CreateReviewModal-module-scss-module__NFtTXa__form__caption",
  "form__dropdown": "CreateReviewModal-module-scss-module__NFtTXa__form__dropdown",
  "form__title": "CreateReviewModal-module-scss-module__NFtTXa__form__title",
  "form__wrapper": "CreateReviewModal-module-scss-module__NFtTXa__form__wrapper",
  "header-1": "CreateReviewModal-module-scss-module__NFtTXa__header-1",
  "main-container": "CreateReviewModal-module-scss-module__NFtTXa__main-container",
  "main-footer-container": "CreateReviewModal-module-scss-module__NFtTXa__main-footer-container",
  "main-header-container": "CreateReviewModal-module-scss-module__NFtTXa__main-header-container",
  "txt-12-bold": "CreateReviewModal-module-scss-module__NFtTXa__txt-12-bold",
  "txt-14-bold": "CreateReviewModal-module-scss-module__NFtTXa__txt-14-bold",
  "txt-14-bold-caps": "CreateReviewModal-module-scss-module__NFtTXa__txt-14-bold-caps",
  "txt-14-med": "CreateReviewModal-module-scss-module__NFtTXa__txt-14-med",
  "txt-16-bold": "CreateReviewModal-module-scss-module__NFtTXa__txt-16-bold",
  "txt-16-med": "CreateReviewModal-module-scss-module__NFtTXa__txt-16-med",
  "txt-18-bold": "CreateReviewModal-module-scss-module__NFtTXa__txt-18-bold",
  "txt-18-medium": "CreateReviewModal-module-scss-module__NFtTXa__txt-18-medium",
  "txt-18-medium-24": "CreateReviewModal-module-scss-module__NFtTXa__txt-18-medium-24",
  "txt-24-semi": "CreateReviewModal-module-scss-module__NFtTXa__txt-24-semi",
});
